import { connect } from "react-redux";
import get from "lodash/get";

import Context from "shared/util/Context";
import {
	closeFinishedBoostModal as closeFinishedBoostModalAction,
} from "ducks/navbar";
import NavBar from "./NavBar";

const startBoost = ({ boostAgainCTA } = {}) => {
	const boostModelLastPromoId = get(window.BoostController, "Model.data.lastpromoid");

	if (boostModelLastPromoId) {
		window.BoostController.closeReport();
	}

	window.BoostController.open(boostAgainCTA ? "boostagain" : "desktopnavbar");
};
const endBoost = () => {
	window.BoostController.cancel();
};

function mapStateToProps(state) {
	const isLoggedIn = !!Context.get("userid");
	const isStaff = !!Context.get("isStaff");
	const isAlist = !!Context.get("isAlist");
	const isFlagMod = !!Context.get("isFlagMod");
	const displayName = Context.get("displayname");
	const thumbnail = Context.get("thumbnail");

	return {
		isLoggedIn,
		isStaff,
		isAlist,
		isFlagMod,
		displayName,
		thumbnail,

		startBoost,
		endBoost,

		...state.navbar,
	};
}

const mapDispatchToProps = {
	closeFinishedBoostModal: closeFinishedBoostModalAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(NavBar);



// WEBPACK FOOTER //
// ./src/shared/components/NavBar/index.js